const LeafTest = () => {
    return (
        <div className="w-max mx-auto text-center text-white absolute slate">
            <h1 className="font-bold mb-4 text-xl md:text-4xl lg:text-8xl">{"{fs"}</h1>
            <p className="font-bold mb-4 text-lg md:text-xl lg:text-4xl">Tutorial Walkthroughs to show</p>
            <p className="font-bold text-lg md:text-xl lg:text-4xl">you how it works</p>
        </div>
    )
}
export default LeafTest;